import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const setUserPassword = async (password, email) => {
    try {
      const data = JSON.stringify({
        svc: "crm_login",
        pid: "setUserPassword",
        dat: {
          username: email,
          password: password,
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const setUserPIN = async (pin, email) => {
    try {
      // console.log(userid, list);
      const data = JSON.stringify({
        svc: "crm_login",
        pid: "setUserPin",
        dat: {
          username: email,
          pin: pin,
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  
  export const verifyCode = async (
    country, 
    verificationtype, 
    emailusername,
    mobilenumber
) => {
    try {
      // console.log(userid, list);
      const data = JSON.stringify({
        svc: "crm_login",
        pid: "verifymobilenumber",
        dat: {
          country: country,
          verificationtype: verificationtype,
          emailusername: emailusername,
          mobilenumber: mobilenumber
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
  